module.exports = __webpack_public_path__ + "img/党建活动@2x.99b72b38.png";